const announcementTypes = {
  SET_ANNOUNCEMENTS: 'SET_ANNOUNCEMENTS',
  SET_ANNOUNCEMENT_LOGS: 'SET_ANNOUNCEMENT_LOGS',
};

export default announcementTypes;
